<template>
  <p :class="['progress-row', { 'is-aligned-right': alignRight }]">
    <img v-for="n in filledDotesCount || 0" :key="n" :src="filledDote" alt="progress filled dote" />
    <img v-for="n in emptyDotesCount || 0" :key="dotesCount + n" :src="emptyDote" alt="progress empty dote" />
  </p>
</template>

<script>
export default {
    name: 'ProgressRow',
    props: {
        value: {
            type: Number,
            required: true,
        },
        maxValue: {
            type: Number,
            default: 1,
        },
        dotesCount: {
            type: Number,
            default: 5,
        },
        alignRight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filledDote() {
            return require('@/assets/images/icons/progress-dote_filled.svg');
        },
        emptyDote() {
            return require(`@/assets/images/icons/progress-dote_empty${this.$store.getters.isThemeDark ? '_light' : ''}.svg`);
        },

        ratio() {
            return this.value / this.maxValue;
        },
        filledDotesCount() {
            const result = Math.ceil(this.dotesCount * this.ratio);
            return result > this.dotesCount ? this.dotesCount : result;
        },
        emptyDotesCount() {
            return this.dotesCount - this.filledDotesCount;
        },
    },
};
</script>
